import { createStore } from "vuex"
import createPersistedState from "vuex-persistedstate"
import SecureLS from "secure-ls"

import auth from "./modules/auth"
import pdf from "./modules/pdf"


const ls = new SecureLS({ isCompression: false });

export default createStore({
	namespaced: true,
	modules: {
		auth,
		pdf
	},
	plugins: [
		createPersistedState({
			key: "spark",
			paths: ["auth"],
			storage: {
				getItem: (key) => ls.get(key),
				setItem: (key, value) => ls.set(key, value),
				removeItem: (key) => ls.remove(key),
			},
		}),
	],
});